import { render, staticRenderFns } from "./Nonpay-statistics.vue?vue&type=template&id=50078709&"
import script from "./Nonpay-statistics.vue?vue&type=script&lang=js&"
export * from "./Nonpay-statistics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports